const divisionLabels: Record<string, string> = {
  '1': 'I',
  '2': 'II',
  '3': 'III',
}

export function RankEmblem({
  rankId,
  label,
  size = 'medium',
}: {
  rankId: string
  label?: string
  size?: 'small' | 'medium' | 'large'
}) {
  const [family, division = ''] =
    rankId === 'tnt_legend' ? ['legend', ''] : rankId.split(/_(?=\d$)/)
  const divisionLabel = divisionLabels[division] ?? '◆'

  return (
    <span
      aria-label={label}
      className={`rank-emblem rank-emblem--${family} rank-emblem--${size}`}
      role={label ? 'img' : undefined}
      title={label}
    >
      <span className="rank-emblem__wings" />
      <span className="rank-emblem__shield">
        <span className="rank-emblem__core" />
        <span className="rank-emblem__division">{divisionLabel}</span>
      </span>
      <span className="rank-emblem__flare" />
    </span>
  )
}
